import { StorageKeys } from '../enums';
import { LocalStorage } from '../util';
export var siteConfigStorage = new LocalStorage(StorageKeys.SiteConfig);
